// extracted by mini-css-extract-plugin
module.exports = {"kitH":"kitH_kitH__4JW_0"};